import config from '@/config/index.js'

export default (to, from, next) => {
	if(config.ENV == 'dev'){
		next()
	}else{
		// console.error(`Trying to reach dev via ${config.ENV}`)
		next({name:'DevelopmentOnly'});
	}
}


// WEBPACK FOOTER //
// ./src/router/DevAuth.js